import { toast } from 'react-toastify';

export const copyCurrentLocationLinkToClipboard = () => {
  const link = window.location.href;
  navigator.clipboard.writeText(link);
  toast.success('Link kopieret til udklipsholderen', { toastId: 'copy-link' });
};
